import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const PreloaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000080;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: ${fadeOut} 0.5s ease-out forwards;
  animation-delay: 2.5s;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PixelLogo = styled.div`
  width: 128px;
  height: 128px;
  image-rendering: pixelated;
  background-color: white;
  mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4 4h24v24H4z M8 8h16v16H8z"/></svg>');
  mask-size: contain;
  margin-bottom: 20px;
`;

const LogoText = styled.div`
  color: white;
  font-family: 'Press Start 2P', monospace;
  font-size: 24px;
  text-align: center;
`;

export const Preloader = ({ onFinish }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      onFinish();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  if (!show) return null;

  return (
    <PreloaderContainer>
      <LogoContainer>
        <PixelLogo />
        <LogoText>DavidOS</LogoText>
      </LogoContainer>
    </PreloaderContainer>
  );
}; 